import React from 'react';

const SvgDown = (props) => (
  <svg width={8} height={10} {...props}>
    <path
      fill="#e25d34"
      fillRule="evenodd"
      stroke="#e25d34"
      strokeWidth={0.5}
      d="M3.514.729l.072 7.696-2.249-2.248-.417.417 2.974 2.973L6.812 6.65l-.425-.425-2.206 2.207-.072-7.7z"
    />
  </svg>
);

export default SvgDown;
